import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';


class releaseSupple  extends React.Component <{}, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      form: {
        variety: '',
        manufactor: '',
        brandNum: '',
        brandName: '',
        num: '',
        price: '',
        place: '',
        warehouse: '',
      }
    };
  }

  public btn = false;

  public componentDidMount() {
  }

  render() {
    return (
      <div>
        <ul className="personal">
          <li>
            <div className="personal-tit"><b>*</b><p>品&emsp;&emsp;种</p></div><input type="text" className="textmarket" value={this.state.form.variety}  onChange={(e) => this.upState(e, 'variety')} />
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>生&nbsp;&nbsp;产&nbsp;&nbsp;商</p></div><input type="text" className="textmarket" value={this.state.form.manufactor}  onChange={(e) => this.upState(e, 'manufactor')} />
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>牌&emsp;&emsp;号</p></div><input type="text" className="textmarket" value={this.state.form.brandNum}  onChange={(e) => this.upState(e, 'brandNum')} />
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>品&emsp;&emsp;牌</p></div><input type="text" className="textmarket" value={this.state.form.brandName}  onChange={(e) => this.upState(e, 'brandName')}/>
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>数&emsp;&emsp;量</p></div><input type="number" className="textmarket" value={this.state.form.num}  onChange={(e) => this.upState(e, 'num')}/>
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>价&emsp;&emsp;格</p></div><input type="number" className="textmarket" value={this.state.form.price}  onChange={(e) => this.upState(e, 'price')}/>
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>地&emsp;&emsp;点</p></div><input type="text" className="textmarket" value={this.state.form.place}  onChange={(e) => this.upState(e, 'place')}/>
          </li>
          <li>
            <div className="personal-tit"><b>*</b><p>仓&emsp;&emsp;库</p></div><input type="text" className="textmarket" value={this.state.form.warehouse}  onChange={(e) => this.upState(e, 'warehouse')}/>
          </li>
        </ul>
        <button className="personal-btn" style={{ background: "#dcdcdc" }} onClick={() => this._release()}>发布 {this.btn}</button>
      </div>
    );
  }

  private upState(e: any, name: string) {
    

    this.setState({
      form: {
        ...this.state.form,
        [name]: e.target.value,
      }
    }, () => {
     
      this._checkForm();
    });
  }

  private _checkForm() {
    const {variety, manufactor, brandNum, brandName, num, price, place, warehouse } = this.state.form;

    if(variety !== '' && manufactor !== '' && brandNum !== '' && brandName !== '' && num !== '' &&  price !== ''  &&  place !== '' &&  warehouse !== '') {
      this.btn = true;
      (document.querySelector('.personal-btn') as any).style.background = '#3f87f7';
    }else {
      this.btn = false;
      (document.querySelector('.personal-btn') as any).style.background = '#dcdcdc';
    }
  }

  private async _release() {
    const {variety, manufactor, brandNum, brandName, num, price, place, warehouse } = this.state.form;

    if(this.btn) {
      const r = await request({
        method: 'post',
        data: {
          gqType: 1,
          gqBreed: variety,
          gqFactory: manufactor,
          gqBrand: brandName,
          gqGrade: brandNum,
          gqNumber: num,
          gqPrice: price,
          gqArea: place,
          gqStore: warehouse,
        },
        url: `${config.API2}safety/supplyBuy/save`,

      })

      if(r.code === 1) {
        (this.props as any).history.push('/supple');
      }else {
        
        this.setState({
          form: {
            variety: '',
            manufactor: '',
            brandNum: '',
            brandName: '',
            num: '',
            price: '',
            place: '',
            warehouse: '',
          }
        },  () => {
          this.btn = false;
          (document.querySelector('.personal-btn') as any).style.background = '#dcdcdc';
          alert(r.message);
        });
      }
    }
  }

}

export default releaseSupple;
